import { useNavigate } from "react-router-dom";
import Card from "./Card";
import { ROUTE } from "../constants";
import useReportStore from "../store/reportStore";
import { getCurrentMerchant } from "../utils/getCurrentMerchant";
import { sendLog } from "../utils/sendLog";

const ReportTypes = ({ reports }) => {
  const navigate = useNavigate();
  const { setReport, resetReport } = useReportStore();
  const currentMerchant = getCurrentMerchant();

  const navigateToReport = (report) => {
    resetReport();
    setReport(report);
    sendLog("report_type_selected", {
      page: "report_types",
      action: `Selected report type: ${report.name}`,
      reportName: report.name,
      merchantName: currentMerchant,
    });
    navigate(`${ROUTE.DASHBOARD}?id=${report.id}`);
  };

  return (
    <div className="center-container">
      {reports.map((report) => (
        <Card
          key={report.id}
          img={report.img}
          name={report.name}
          description={report.description}
          report={report}
          onButtonClick={navigateToReport}
          buttonText={report.btnText || "Select"}
        />
      ))}
    </div>
  );
};

export default ReportTypes;
